import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { Form, Button } from "semantic-ui-react";

import capitalize from "lodash/capitalize";

const fields = [
  {
    label: "fecha",
    required: true,
    type: "datetime-local",
    name: "fecha_cita"
  },
  {
    label: "descripcion",
    name: "descripcion",
    required: true,
    type: "text"
  }
];

class FormNuevaCita extends Component {
  handleReset = () => {
    this.props.reset();
    this.props.handleDescartar();
  };

  renderFields = fields.map(({ label, required, type, name }) => (
    <Field
      key={label}
      fluid
      id={label}
      name={name}
      type={type}
      component={Form.Input}
      label={capitalize(label)}
      required={required}
    />
  ));

  render() {
    const { handleSubmit, pristine, submitSucceeded } = this.props;
    return (
      <Form>
        <Form.Group widths="equal">{this.renderFields}</Form.Group>
        <Button
          disabled={pristine || submitSucceeded}
          content="Guardar"
          color="pink"
          onClick={handleSubmit(values => this.props.handleAddCita(values))}
        />
        <Button content="Descartar" color="pink" onClick={this.handleReset} />
      </Form>
    );
  }
}

export default reduxForm({
  form: "FormNuevaCita",
  enableReinitialize: true
})(FormNuevaCita);



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaCita/FormNuevaCita.jsx